<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content">
	<div *ngIf="fastlaneWizardService.getState().stepIndex === 3">
		<copo-submission-feedback></copo-submission-feedback>
	</div>
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goToBackView()" [titleHeaderText]="pageTitle">
		<button *ngIf="!isLoading && !isSummaryStep() && isButtonNextVisible()" type="submit" mat-flat-button color="primary"
			(click)="goNextStep()">
			<span translate>global.next</span>
		</button>
		<button *ngIf="!isLoading && isSummaryStep()" class="fastlane-submit-btn" type="submit" (click)="evtSubmitOrder()" mat-flat-button color="primary">
			<span class="fastlane-submit-text" translate>fastlane.wizard.summary.submitBtn</span>
		</button>
	</copo-panel-header>
	<div class="copo-wizzard-stepper-container">
		<copo-fastlane-wizard-stepper *ngIf="getCurrentStatus()"></copo-fastlane-wizard-stepper>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<router-outlet
			*ngIf="!isLoading; else loading"
			(activate)="onActivate($event)"
			(deactivate)="onDeactivate()"
			copoAfterViewInit
			(afterviewinit)="scroller.restoreState()"
		></router-outlet>
	</div>
</div>